export function queryAllPieces() {
  return fetch("/server/pieces.php");
}

export function queryCategories() {
  return
}




// WEBPACK FOOTER //
// ./src/queries.js